import { getUser } from "../../utils/auth";

export default function HRDashboard() {
  const user = getUser();

  return (
    <div>
      <h1 className="text-2xl font-bold">HR Dashboard</h1>
      <p className="mt-2">Welcome, <strong>{user?.name}</strong></p>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-4">
        <div className="bg-white p-4 rounded shadow text-center">
          <h3>Total Employees</h3>
          <p>120</p>
        </div>
        <div className="bg-white p-4 rounded shadow text-center">
          <h3>Pending Leaves</h3>
          <p>8</p>
        </div>
        <div className="bg-white p-4 rounded shadow text-center">
          <h3>Approved Leaves</h3>
          <p>25</p>
        </div>
      </div>
    </div>
  );
}